import React, { Component } from 'react';
import {connect} from 'react-redux';
import WordDisplayContainer from '../styled/WordDisplayContainer';
import * as S from '../store/selectors'

export default
@connect(state => {
  return {
    level: state.game.level,
    wordArray: S.word(state),
  }
})
class WordDisplay extends Component {
  render() {
    const arrWordsInGroup = this.props.wordArray;

    const keys = arrWordsInGroup.map((word, idx) => (
      <p key={idx}>{word}</p>
    ));

    return (
      <WordDisplayContainer>
        {keys}
      </WordDisplayContainer>
    );
  }
}
